import ApiService from '@/utils/ApiService'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    retrieved: null
  },
  getters: {
    isLoading: (state) => state.isLoading,
    retrieved: (state) => state.retrieved
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setRetrieved (state, retrieved) {
      state.retrieved = retrieved
    },
    reset (state) {
      state.retrieved = null
      state.isLoading = false
    }
  },
  actions: {
    async retrieve ({ commit }, link) {
      commit('toggleLoading')
      let url = addParamsToQuery(link, { withRelationships: 1 })
      const response = await new ApiService(url).getResults()
      commit('setRetrieved', response)
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
